import { createActions } from 'reduxsauce'

export const { Types, Creators } = createActions({
  setError: ['error']
});